var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-integral-goods-group-form',{staticClass:"pt-integral-goods-group-form__page",attrs:{"is-edit":_vm.is_edit,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }